<template>
  <div class="career-div">

    <MenuSide></MenuSide>
    <div v-if="!this.isMobile" class="banner">

      <img class="bg" src="/static/img/banners/hippo-team-pic.3f3ba95.jpg" srcset="/static/img/banners/hippo-team-pic.3f3ba95.jpg"
           alt="Hippotec">

      <div class="container logo">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image">DON'T MISS OUT</div>
            <div class="title-image">YOUR OPPORTUNITY</div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small">Join our team. Be a part of the experience, dare to dream with us.</div>
            <div class="title-image-small">Now it's your time to take a part of the amazing digital world.<br/>
              We’re hiring!!!
            </div>
          </div>
        </div>
      </div>
      <div class="overlay"></div>
    </div>
    <div v-else class="mobile-banner">

      <img class="bg" src="/static/img/hippo-team-pic.3f3ba95.jpg" srcset="/static/img/hippo-team-pic.3f3ba95.jpg"
           alt="Hippotec">

      <div class="container uppertext">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">DON'T</div>
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">MISS OUT YOUR</div>
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">OPPORTUNITY</div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small">Join our team. Be a part of the experience, dare to dream with us.</div>
            <div class="title-image-small">Now it's your time to take a part of the amazing digital world.<br/>
              We’re hiring!!!
            </div>
          </div>
        </div>
      </div>
      <div class="overlay"></div>
    </div>
    <div>
      <div v-if="jobs.length > 0" class="career-descriptiondiv">
        <div class="career-descriptiontext">
          <div class="job-list">
            <div class="job-list-item" v-for="(job, index) in jobs">
              <CareerItem :item=job></CareerItem>
            </div>
          </div>

        </div>
      </div>
      <div v-else class="no-jobs">
        <img src="../../static/img/global/no-careers.svg">
        <h1 class="no-job-title">Sorry</h1>
        <h5 class="no-job-sub-title">
          We currently have no open positions</h5>
        <button @click="seeOurProjects" class="viewourwork">VIEW OUR WORK</button>
<!--        <div style="margin-left: -260px;">
          <ContactUs></ContactUs>
        </div>-->
      </div>
    </div>
    <div class="contact-info">
    <ContactUs></ContactUs>
    </div>
  </div>
</template>
<script>
  import bg from '../../static/img/Career/hippo-team-pic.jpg'
  import bgmobile from '../../static/img/Career/hippoPic.png'
  import logo from '../../static/img/Career/group-2.png'
  import logomobile from '../../static/img/Career/logomobile.png'
  //import MenuSide from './../components/MenuSide'
  //import CareerItem from "../components/CareerItem";
  //import ContactUs from "../components/ContactUs";
  import backgroundmobileimage from "../../static/img/banners/adult-agency-business2.8edc0c5.jpg";

  import CareerItem from '@bit/hippotec.website2019.career-item';
  import MenuSide from '@bit/hippotec.website2019.menu-side';
  import ContactUs from '@bit/hippotec.website2019.contact-us';

  export default {
    name: 'Career',
    data() {
      return {
        backgroundImage: bg,
        logoNew: logo,
        jobs: window.jobsData,
        // readTitle: "Read More",
        hide: false,
        window,
        mobileSite: {
          titleFontSize: "60px"
        }
      }
    },
    components: {
      ContactUs,
      MenuSide: MenuSide,
      CareerItem: CareerItem
    },
    methods: {
      seeOurProjects: function () {
        this.$router.push('projects')
      },
      readMore: function () {
        this.hide = !this.hide
      },
      prepareMobile(isMobile) {
        //console.log(isMobile);
        this.isMobile = isMobile;
        if (isMobile) {
          this.mobileSite.titleFontSize = '40px';
          this.logoNew = logomobile
          this.backgroundImage = bgmobile
        }else{
          this.logoNew = logo
          this.backgroundImage = bg
        }
      }
    },
    created() {
      this.prepareMobile(localStorage.isMobile == 'true');
      this.logoNew = window.innerWidth > 600 ? logo : logomobile
      this.backgroundImage = window.innerWidth > 600 ? bg : bgmobile
    }
  }

</script>
<style lang="scss" scoped>
  @import "../assets/scss/career";

  .contact-info{
    margin-top: 650px;
  }

  .mobile-banner {
    width: 100%;
    height: 520px;
    overflow: hidden;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
      object-position: center;
    }

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60%;
      max-width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      z-index: 1;

      img {
        zoom: 1.2;
        width: 174px;
        height: 98px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 20px;
      }

      p {
        width: 969px;
        max-width: 100%;
        margin: auto;
        color: #fff;
        font-size: 33px;
        font-weight: 300;
        text-align: center;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
    .uppertext {
      position: absolute;
      top: 100px;
      left: 35px;
      width: 90%;
      max-width: 100%;
      //text-align: center;
      // transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
  .uppertext {
    position: absolute;
    top: 100px;
    left: 35px;
    width: 90%;
    max-width: 100%;
    //text-align: center;
    // transform: translate(-50%, -50%);
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Career.vue